module.exports = __webpack_public_path__ + "static/media/Nokora-Regular.34cad290.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Nokora-Regular.ttf
// module id = 549
// module chunks = 0